import { IconSymbol } from '@uhg-abyss/web/ui/IconSymbol';
import { Popover } from '@uhg-abyss/web/ui/Popover';
import React from 'react';

import { afterHoursPopoverStyle } from './PopOver.style';

export const AfterHoursPopoverIcon = ({ isOpen, setIsOpen, content }) => (
  <Popover
    content={content}
    css={afterHoursPopoverStyle}
    data-auto-testid="after-hours-info-popover"
    data-testid="after-hours-info-popover"
    onOpenChange={() => setIsOpen(!isOpen)}
    open={isOpen}
  >
    <IconSymbol
      data-auto-testid="after-hours-info-icon"
      data-testid="after-hours-info-icon"
      icon="info"
      onClick={() => setIsOpen(true)}
      size={24}
      style={{ cursor: 'pointer' }}
      variant="outlined"
    />
  </Popover>
);
